module.exports = __webpack_public_path__ + "static/media/cat-space.b69dac13.svg";